import { AppState } from '..'

export const SelectLoggedInUser = (state: AppState) => state.loggedInUser
export const SelectLoggedInUserIsStateReady = (state: AppState) => state.loggedInUser.isStateReady
export const SelectIsInhouse = (state: AppState) =>
  state.loggedInUser.roles.findIndex(r =>
    ['admin', 'insight:admin', 'insight:editor', 'insight:viewer'].includes(r)
  ) !== -1
